<template>
  <div 
  class="rounded-xl py-6 px-4 -mt-4"
  :style="cartProcessInputRadius"
  >
    <!-- Enter discount code and alert -->
    <section>
        <text-input 
        v-model="currentDiscountCode"
        :onInput="handleInput"
        class="bg-white-400 rounded-lg w-full text-black px-1.5 py-3 placeholder-black" 
        type="text" 
        :style="cartProcessInputRadius"
        placeholder="Enter code..." />

      <transition name="fade">
        <discount-alert 
        :showAlert="this.currentDiscountCode != '' && !this.discount.isDiscountCodeValid"
        :value="lang['discount_invalid_code'][language]"/>
      </transition>
    </section>
    <!-- List all the discounts and alert -->
    <section>
      <ul>
        <transition name="fade">
          <discounts-list-item 
          @delete-coupon="handleDeleteCoupon"
          v-for="(coupon) in discount.discountCodes" 
          :key="coupon.id" 
          :coupon="coupon" />
        </transition>
      </ul>

      <discount-alert
      :showAlert="showAlert(discount.discountCodes[0])"
      :value="alertMessage" />
    </section>

    <!-- Total of applied discounts -->
    <transition name="fade">
      <discount-applied
      :showDiscountApplied="showDiscountApplied(discount.discountCodes[0])" 
      :discountIsApplied="discountIsApplied"
      :discountAmount="discountAmount" />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from "lodash";

import lang from "../../lang";

import TextInput from '../Input/TextInput.vue';
import DiscountAlert from './DiscountAlert.vue';
import DiscountApplied from './discountApplied.vue';
import DiscountsListItem from './DiscountsListItem.vue';

export default {
  props: { },
  components: {TextInput, DiscountsListItem, DiscountAlert, DiscountApplied},
  data() {
    return {
      lang: lang,
      alertMessage: '',
      discountIsApplied: {},
      currentDiscountCode: '',
    }
  },
  computed: {
    ...mapGetters("Theme", [
      "cartProcessInputRadius"
    ]),
    ...mapGetters("Cart", [
      "discount",
      "totalPriceValue",
      "tipAmount",
      "cartItems",
      "discountAmount",
      "automaticDiscount"
    ]),
    ...mapGetters(["language", "currency"])
  },
  methods: {
    handleInput: _.debounce(function (event) {
      // Typed input is delayed for better UI/UX experience
      this.currentDiscountCode = event.target.value;
      // Check if coupon is valid
      this.$store.dispatch("Cart/VALIDATE_DISCOUNT_CODE", event.target.value);
    },1500),
    handleDeleteCoupon(coupon) {
      this.currentDiscountCode = '';
      // Delete discount code from store
      this.$store.commit("Cart/deleteDiscountCode", coupon);
    },
    showAlert(discountCode) {
      // Different reasons why an alert can be shown
      // Each reason has it's own IF-condition
      // each with different error messages
      // these can be found in the translations file
      if (!discountCode){
        // No discount code is found
        return false;
      }
      // If the total amount(incl. tips) is smaller than minimum spent amount of the coupon
      if(this.totalPriceValue + this.tipAmount < discountCode.minimum_spent) {
        this.alertMessage = lang["discount_min_price"][this.language];
        this.alertMessage += this.currency;
        this.alertMessage += discountCode.minimum_spent;

        return true
      }
      // If the maximum discount percentage of coupon is reached
      if(discountCode.type === 'FixedAmount' &&
        this.totalPriceValue < discountCode.value) {
          this.alertMessage = lang["discount_error"][this.language];

          return true
      }
      // If minimum amount items not reached
      if(this.cartItems.length < discountCode.minimum_items) {
        this.alertMessage = lang["discount_low_items"][this.language];
        this.alertMessage += discountCode.minimum_items;
        this.alertMessage += lang["items"][this.language];

        return true;
      }
      // If max percentage amount is reached
      if(discountCode.type == 'Percentage' &&
        this.discount.discountAmount >= discountCode.max_disc_amount_percentage &&
        discountCode.max_disc_amount_percentage !== 0) {
          this.alertMessage = lang["discount_max_reached"][this.language];
          this.alertMessage += this.currency;
          this.alertMessage += discountCode.max_disc_amount_percentage;

          return true;
      }

      return false;
    },
    showDiscountApplied(discountCode) {
      // Check if the coupon can be applied, are all the conditions met: see showAlert method
      // and show the applied amount to user
      if (!discountCode) {
        return false
      }

      if (this.cartItems.length >= discountCode.minimum_items &&
      this.totalPriceValue + this.tipAmount >= discountCode.minimum_spent &&
      this.totalPriceValue >= discountCode.value) {
        this.discountIsApplied = discountCode;

        return true;
      }

        return false;
    }
  },
  mounted() {
    if (this.automaticDiscount != false) {
      this.currentDiscountCode = this.automaticDiscount.code
      this.handleInput({ target: { value: this.automaticDiscount.code } })
      this.$store.commit("Cart/toggleIsDiscountCodeValid", true);
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 1.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>